const apiCodes = {
  // HTTP Status Codes
  SUCCESS: 200,
  INTERNAL_SERVER_ERROR: 500,
  UNAUTHORIZE_REQUEST: 401,
  RESOURCE_NOT_FOUND: 404,
  USER_NOT_FOUND:400,
  FORBIDDEN: 403,
  API_RELOAD: 5000,
  REQUEST_TIME_OUT: 'ECONNABORTED',
  RESPONSE_SUCCESS: 'Success'
};

export default apiCodes;
